import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide6 from './slide_6.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide6 />
        </div>
        <div className={s.textWrapper}>
            <p>
                A decision log is created, displaying each step of how the
                conclusion was reached, and how each virtual expert was
                constructed.
            </p>
            <p>
                <em>
                    100% transparency of all data giving a fully documented
                    process.
                </em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide6.component.js